export enum OfferType {
  GENERALIZED = 'GENERALIZED',
  PERSONALIZED = 'PERSONALIZED',
  EXISTING = 'EXISTING',
}
